import { IBaseClientAdmin, IClientAdmin } from 'types/income';
import { converters as tableConverters } from 'store/table';
import { BaseClientAdmin, ClientAdmin } from './admin-client-admins.types';
import { loaders } from './admin-client-admins.loaders';

export const convertBaseAdmin = (admin: IBaseClientAdmin): BaseClientAdmin => {
  return {
    id: admin.id,
    status: admin.status,
    adminRole: {
      id: admin.adminRole.id,
      name: admin.adminRole.name,
      description: admin.adminRole.description ?? '',
      roleType: admin.adminRole.roleType,
    },
    fullName: admin.fullName ?? '',
    email: admin.email ?? '',
    phone: admin.phone ?? '',
  };
};

export const convertAdmin = (admin: IClientAdmin): ClientAdmin => {
  return {
    ...convertBaseAdmin(admin),
    firstName: admin.firstName,
    lastName: admin.lastName,
    fullName: [admin.firstName, admin.lastName].filter(Boolean).join(' '),
    root: admin.root,
  };
};

const convertAdmins = (admins: IBaseClientAdmin[]): BaseClientAdmin[] => {
  return admins.map(convertBaseAdmin);
};

export const converters = {
  getAdmins: ({ data }: Awaited<ReturnType<typeof loaders.getAdmins>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertAdmins(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getAdmin: ({ data }: Awaited<ReturnType<typeof loaders.getAdmin>>) => {
    return convertAdmin(data);
  },
};
